import React from "react";
import { getProcessedTextPreview } from "../../../utilities/NewsUtilities";
import { formatDisplayDate } from "../../../utilities/CommonUtilities";

const NewsItem = ({ news, onClick }) => {
  const displayDate = formatDisplayDate(new Date(news.data_timestamp));
  const title = news.document_name
    ? news.document_name
    : getProcessedTextPreview(news.processed_text, 100);

  const relevanceIndicator = (() => {
    const score = news.ner_relevance_score;
    if (score > 0.5) {
      return {
        color: "green",
        icon: <i className="fa-solid fa-caret-up" />,
        title: "High Relevance",
      };
    } else if (score > 0) {
      return {
        color: "#ffc107",
        icon: <i className="fa-solid fa-xs fa-circle" />,
        title: "Moderate Relevance",
      };
    } else {
      return {
        color: "red",
        icon: <i className="fa-solid fa-caret-down" />,
        title: "Low Relevance",
      };
    }
  })();

  return (
    <div
      className="card mb-3 shadow-sm "
      onClick={onClick}
      style={{
        cursor: "pointer",
      }}
    >
      <div className="card-body ">
        <div className="d-flex justify-content-between align-items-center">
          <div className="w-100 text-dark-gray">
            <h5 className="card-title">{title}</h5>
            <div className="text-muted d-flex justify-content-start gap-2 align-items-center mb-2">
              <div>
                <a
                  href={news.public_data_source_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted"
                  onClick={(e) => e.stopPropagation()}
                >
                  <i className="fa-solid fa-globe" /> Source
                </a>
              </div>
              |
              <div>
                <i className="fa-regular fa-calendar me-2" />
                {displayDate}
              </div>
              {news.ner_relevance_score && (
                <div>
                  | Relevance:
                  <span
                    style={{
                      color: relevanceIndicator.color,
                      fontSize: "15px",
                    }}
                    title={relevanceIndicator.title}
                    className="ms-2"
                  >
                    {relevanceIndicator.icon}
                    {"  "}
                    {news.ner_relevance_score}
                  </span>
                </div>
              )}
            </div>
            {news.translated_document_name && (
              <div className="text-muted">
                Translation: {news.translated_document_name}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsItem;
